import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-shield-check-line",
    title: "官方认证",
    desc: "所有入口地址均经过官方认证，确保安全可靠",
  },
  {
    icon: "ri-flashlight-line",
    title: "极速访问",
    desc: "智能CDN加速，全球节点覆盖，访问延迟低至毫秒级",
  },
  {
    icon: "ri-smartphone-line",
    title: "无需下载",
    desc: "浏览器直接访问，不占手机存储，跨平台通用",
  },
  {
    icon: "ri-refresh-line",
    title: "实时更新",
    desc: "入口地址实时维护更新，确保始终可用",
  },
];

const features = [
  {
    icon: "ri-computer-line",
    title: "跨平台兼容",
    desc: "支持Windows、Mac、Linux等所有主流操作系统，无论使用什么设备都能通过浏览器顺畅访问JM网页版。",
  },
  {
    icon: "ri-lock-line",
    title: "银行级加密",
    desc: "采用SSL/TLS加密传输技术，所有数据全程加密，确保您的账号信息和操作数据安全无忧。",
  },
  {
    icon: "ri-loop-left-line",
    title: "数据实时同步",
    desc: "JM网页版与APP端数据完全实时同步，您在网页版上的每一次操作都会即时同步到所有设备。",
  },
  {
    icon: "ri-speed-up-line",
    title: "性能优化",
    desc: "经过深度优化的页面加载速度，即使在低配置设备或弱网环境下也能提供流畅的使用体验。",
  },
  {
    icon: "ri-moon-line",
    title: "夜间模式",
    desc: "内置夜间模式功能，自动适配系统设置，在暗光环境下有效保护您的视力。",
  },
  {
    icon: "ri-keyboard-line",
    title: "快捷键支持",
    desc: "丰富的键盘快捷键支持，让熟练用户可以大幅提升操作效率，享受行云流水的使用体验。",
  },
];

export default function HomeFeatures() {
  return (
    <>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              为什么选择JM网页版
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              JM网页版的核心优势
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              JM网页版为您提供与APP完全一致的功能体验，同时带来更多独特的便利
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {highlights.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-accent-300 transition-all duration-300 group cursor-default"
              >
                <div className="w-11 h-11 flex items-center justify-center bg-accent-100 rounded-lg mb-4 group-hover:bg-accent-500 transition-colors duration-300">
                  <i className={`${item.icon} text-lg text-accent-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              功能亮点
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              全方位提升您的使用体验
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              JM网页版不断优化升级，为您带来更便捷、更安全、更智能的在线服务体验
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {features.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-secondary-300 transition-all duration-300 group cursor-default"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-lg mb-4 group-hover:bg-secondary-500 transition-colors duration-300">
                  <i className={`${item.icon} text-lg text-secondary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              使用步骤
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              三步轻松开始使用JM网页版
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              无需复杂操作，简单三步即可开始您的JM网页版之旅
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {[
              {
                step: "01",
                icon: "ri-compass-3-line",
                title: "访问官方入口",
                desc: "通过本页面提供的JM网页版官网入口，使用浏览器打开官方登录页面",
              },
              {
                step: "02",
                icon: "ri-user-line",
                title: "登录您的账号",
                desc: "使用已注册的手机号或邮箱登录，新用户可以先完成快速注册",
              },
              {
                step: "03",
                icon: "ri-rocket-line",
                title: "开始使用",
                desc: "登录成功后即可使用JM网页版的全部功能，与APP数据完全同步",
              },
            ].map((item, idx) => (
              <div key={idx} className="text-center group">
                <div className="relative mb-5">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center bg-accent-500 rounded-2xl group-hover:scale-110 transition-transform duration-300">
                    <i className={`${item.icon} text-2xl text-background-50`}></i>
                  </div>
                  <span className="absolute -top-2 -right-2 w-8 h-8 flex items-center justify-center bg-background-50 border-2 border-accent-500 rounded-full text-xs font-bold text-accent-600">
                    {item.step}
                  </span>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                {idx < 2 && (
                  <div className="hidden md:block absolute right-0 top-8 transform translate-x-1/2">
                    <i className="ri-arrow-right-line text-2xl text-foreground-300"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}